import template from './rw-currency.html';

export default {
  template,
  controller: 'RwCurrencyController',
  bindings: {
    fraction: '@',
    value: '<',
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-currency/rw-currency-component.js